module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/classic_1-d143e25d7dbb21ea743991cef492e5f8.png";